export { default as LoginPage } from './LoginPage';
export { default as IsLoggedIn } from './IsLoggedIn';
export { default as IsAdmin } from './IsAdmin';
export { default as IsFederation } from './IsFederation';
export { default as IsVisitor } from './IsVisitor';



// WEBPACK FOOTER //
// ./src/containers/auth/index.js